module.exports = __webpack_public_path__ + "img/meihua.610abb0e.gif";